import axios from "../../AxiosInstance"

const getForums = (filters) =>
    axios.get(`api/forums?isFavorite=${filters?.isFavorite ?? false}&axisId=${filters?.axisId}`)

const getForumById = (forumId) => axios.get(`api/forums/${forumId}`)

const getAxis = () => axios.get("api/axis")

const postForumAnswers = (payload) => axios.post("api/answers", payload)

const putForumAnswer = (payload) => axios.put(`api/answers/${payload.id}`, payload)

const deleteForumAnswer = (messageId) => axios.delete(`api/answers/${messageId}`)

const setForumFavorite = (forumId) => axios.post(`api/forums/${forumId}/setFavorite`)

const removeFavorite = (forumId) => axios.post(`api/forums/${forumId}/removeFavorite`)

const reportMessage = (messageId) => axios.post(`api/answers/${messageId}/report`)

const createForum = (payload) => axios.post("api/forums", payload)

export const ForumService = {
    getForums,
    getForumById,
    getAxis,
    postForumAnswers,
    putForumAnswer,
    setForumFavorite,
    removeFavorite,
    reportMessage,
    createForum,
    deleteForumAnswer
}
